<app-grid
  #grid
  *ngIf="!show"
  [rowData]="rowData"
  [columnDefs]="columnsDef"
  [rowHeight]="45"
  [columnSizeMode]="columnSizeMode"
  [isMasterDetail]="true"
  [pagination]="true"
  [useAddAction]="isProjectOwnershipValid"
  addLabel="Add Scheme"
  [rowData]="rowData"
  [useDeleteAction]="true"
  [useModels]="true"
  [compartment]="compartment"
  [selectedProject]="selectedProject"
  [isProjectOwnershipValid]="isProjectOwnershipValid"
  [detailAutoRowHeigth]="true"
  [detailColumnDefs]="detailsColumnDef"
  (deleteEvent)="deleteRow($event)"
  (DeleteDetailEvent)="onDeleteDetails($event)"
  (selectionChangedEvent)="dropDownSelectionChanged($event)"
  (dropDownSelectionChangeEvent)="dropDownSelectionChanged($event)"
  (addEvent)="newRowAdded($event)"
  (onModelOptionsChangedEvent)="onModelOptionsChanged($event)"
  (onClickButtonEvent)="onClickButtonEvent($event)"
  (onBlurInputText)="onBlurInputText($event)"
  (onCheckboxSelectedEvent)="onCheckboxSelectedChanged($event)"
  (calendarDetailsSelectionChangeEvent)="onCalendarSelectionChanged($event)"
  (enableControlsEmit)="enableControls($event)"
  [rowMultiSelectWithClick]="true"
  [rowSelection]="'multiple'"
  [suppressRowClickSelection]="true"
  (onSelectedRowEvent)="onSelectedRow($event)"
  (onSelectAllClicked)="onBtnSelectAllClicked()"
  (onRowSelectedEmit)="onSelectionChanged($event)"
  (onRowExpanded)="onRowExpanded($event)"
></app-grid>

<eea-gap-surfacewater-pwc-scenarios
  *ngIf="showScenarios()"
  [row]="selectedRow"
  [isProjectOwner]="isProjectOwnershipValid"
  [isPwcV2]="isPwcV2"
  (onSelectScenarios)="onSelectScenarios($event)"
/>
